import { TcTrackPoint } from "../data/type";

export const cache: Record<string, AMap.CircleMarker[]> = {};

export function addCircleMarkersToMap(
  eventId: string,
  map: any,
  pointArray: TcTrackPoint[],
  t: any,
  isShowTcTrack: boolean,
) {
  if (!!cache[eventId] && cache[eventId].length) {
    map.add(cache[eventId]);
    return cache[eventId];
  }

  // 创建一个信息窗体实例
  const infoWindow = new AMap.InfoWindow({
    offset: new AMap.Pixel(0, -10), // 信息窗体相对于点的偏移量
    closeWhenClickMap: true, // 点击地图关闭窗体
    autoMove: true, // 自动调整窗体到视野内
    isCustom: true
  });

  const circleMarkers = pointArray.map(point => {
    // 设置初始半径
    const initialRadius = 5;
    const hoverRadius = 8; // 鼠标悬停时的放大半径

    const fillColor = point.isForecast ? "#666" : point.color;

    const marker = new AMap.CircleMarker({
      center: new AMap.LngLat(
        point.geometry.coordinates[0],
        point.geometry.coordinates[1]
      ),
      radius: initialRadius,
      strokeColor: "#fff",
      strokeWeight: 2,
      strokeOpacity: 0.8,
      fillColor,
      fillOpacity: 0.8,
      zIndex: 999,
      cursor: "pointer",
      bubble: true
    });

    // 鼠标移入显示信息窗体和放大点
    marker.on("mouseover", function(e: any) {
      // 放大点
      marker.setRadius(hoverRadius);

      // 显示信息窗体
      const content = `
        <div style="padding: 10px; font-size: 12px; background-color: #000000; color: #ffffff; border-radius: 4px; opacity: 0.9;">
          <p style="margin: 0;">${point.trackdate}</p>
          <p style="margin: 0;">${t("events.trackInfo.WindSpeed")}: ${point.windspeed} km/h (${point.windspeedT.toFixed(1)} m/s)</p>
          <p style="margin: 0;">${t("events.trackInfo.TcCategory")}: ${t("events.trackInfo.Tropical Storm")}</p>
          <p style="margin: 0;">${t("events.trackInfo.Source")}: GDACS</p>
        </div>
      `;
      infoWindow.setContent(content);
      infoWindow.open(map, e.target.getCenter(), 3);
    });

    // 鼠标移出隐藏信息窗体并恢复点大小
    marker.on("mouseout", function() {
      // 恢复原始大小
      marker.setRadius(initialRadius);

      // 关闭信息窗体
      infoWindow.close();
    });

    return marker;
  });

  map.add(circleMarkers);

  cache[eventId] = circleMarkers;

  if(!isShowTcTrack){
    hidePoint(eventId);
  }

  return circleMarkers;
}

export function clearPoint(eventId: string, map: any) {
  // 检查缓存中是否存在该事件的标记
  if (!cache[eventId] || !cache[eventId].length) {
    return;
  }

  // 从地图中移除所有标记
  map.remove(cache[eventId]);

  // 清除缓存
  delete cache[eventId];
}

export function hidePoint(eventId: string) {
  // 检查缓存中是否存在该事件的标记
  if (!cache[eventId] || !cache[eventId].length) {
    return;
  }

  // 获取缓存的标记
  const markers = cache[eventId];
  
  markers.forEach(marker => {
    if (!marker.getMap()) {
      return;
    } 
    marker.hide();
  });
}

export function showAllPoints() {
  // 遍历所有事件
  Object.keys(cache).forEach(eventId => {
    const markers = cache[eventId];
    
    if (markers && markers.length) {
      // 将标记添加到地图或使其可见
      markers.forEach(marker => {
        if (marker.getMap()) {
          marker.show();
        } else {
          // map.add(marker);
        }
      });
    }
  });
}

export function hideAllPoints() {
  // 遍历所有事件
  Object.keys(cache).forEach(eventId => {
    const markers = cache[eventId];
    
    if (markers && markers.length) {
      // 隐藏标记
      markers.forEach(marker => {
        if (!marker.getMap()) {
          return;
        } 
        marker.hide();
      });
    }
  });
}
